import { BaseAction } from "../../../core/actions/BaseAction";
import { _eventBus } from "../../../core/events/EventBus";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { updateRecoilState, useRecState } from "../../../Orchestrator/Recoils/Events/Recoil";


export class MenuSelectAction extends BaseAction<void, { path: string, isAuthenticated?: boolean, isRoute?: boolean }> {

    override async run(): Promise<void | null> {
        try {
            const { path, isAuthenticated, isRoute } = this.params!;
            updateRecoilState("selectedMenuAtom", path)

            if (isRoute) {
                switch (path) {
                    case "search":
                        if (isAuthenticated) {
                            _eventBus.emit({
                                eventName: "ROUTE_CHANGE",
                                data: "/search",
                            })
                        } else {
                            _eventBus.emit({
                                eventName: "ROUTE_CHANGE",
                                data: "/",
                            })
                        }
                        break;
                    case "bookings":
                        _eventBus.emit({
                            eventName: "ROUTE_CHANGE",
                            data: "/bookings",
                        })
                        break;
                    case "offers":
                        updateRecoilState("offersPageViewAtom", "listing");
                        _eventBus.emit({
                            eventName: "ROUTE_CHANGE",
                            data: "/offers",
                        })
                        _eventBus.emit({
                            eventName: evtTree.CMSOffers.OfferPass.Back,
                        })
                        break;

                    case "networks-maps-stations":
                        _eventBus.emit({
                            eventName: "ROUTE_CHANGE",
                            data: "/networks-maps-stations",
                        })
                        break;

                    case "journey-planner":
                        _eventBus.emit({
                            eventName: "ROUTE_CHANGE",
                            data: "/journey-planner",
                        })
                        break;

                    case "destinations":
                        _eventBus.emit({
                            eventName: "ROUTE_CHANGE",
                            data: "/destinations",
                        })
                        break;

                    case "live-schedule":
                        _eventBus.emit({
                            eventName: "ROUTE_CHANGE",
                            data: "/live-schedule",
                        })
                        break;

                    default:
                        _eventBus.emit({
                            eventName: "ROUTE_CHANGE",
                            data: "/",
                        })
                        break;
                }
            }

        } catch (error) {
            console.error("Error in MenuSelectAction:", error);
        }
    }
}

// Create a singleton instance
export const menuSelectAction = new MenuSelectAction(); 